import React from "react";
export const styles = {
    paperStyle: {
        padding: 30,
        width: "80%",
        maxWidth: 800,
        margin: "50px auto",
        textAlign: "center",
        borderRadius: "16px",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
        background: "#fdfdfd",
    },
    mainContainer: {
        minHeight: "100vh",
        backgroundColor: "#f5f7fa"
    },
    title: {
        color: "#1976d2",
        fontWeight: "bold",
        mb: 2
    },
    miniContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 3,
    },
    maintenanceMessageStyle: {
        color: "#d32f2f",
        fontWeight: 500
    },
    messageTxt: {
        mt: 2,
        color: "#555"
    }
}